import "#legacy/shared/client/jst.js";
import "#/legacy/namespaces.js";
import "#finder-legacy/physician_finder/views/base.js";

DoctorFinder.Views.ListResults = class ListResults extends DoctorFinder.Views.Base {
  constructor() {
    super(...arguments);
  }

  initialize() {
    this.initialize = this.initialize.bind(this);
    this.handleResultSelected = this.handleResultSelected.bind(this);
    this.handleMobileBreakpointEnter = this.handleMobileBreakpointEnter.bind(this);
    this.handleMobileBreakpointExit = this.handleMobileBreakpointExit.bind(this);
    this.handleViewChange = this.handleViewChange.bind(this);
    this.render = this.render.bind(this);

    this.$el.addClass("bio");
    this.$el.addClass("bio--list");
    super.initialize(...arguments);

    // BEHAVIOUR

    this.listenTo(this.collection, "change:selectedResult", this.handleResultSelected);
    return this.listenTo(this.collection, "change:selectedView", this.handleViewChange);
  }

  // EVENT HANDLERS

  handleResultSelected(resultGUID) {
    if (!this.isMobileSize() && resultGUID) {
      return this.collection.selectView("map");
    }
  }

  handleMobileBreakpointEnter() {
    super.handleMobileBreakpointEnter();
    this.collection.selectView("bio");
    return this.collection.unselectResult(); // Unselect the result because it might be a little jarring to transition into a mobile map from a desktop map
  }

  handleMobileBreakpointExit() {
    super.handleMobileBreakpointExit();
    return this.collection.unselectResult(); // Unselect the result because the mobile map won't be visible so we don't want to retain a selection
  }

  handleViewChange() {
    if (this.collection.selectedView === "bio") {
      return this.collection.unselectResult();
    } // Unselect the result because we don't have a selected result representation for the list view
  }

  // RENDERING

  // `sp-finder-result-view` renders the list from the finder's published results.
  render() {
    return this;
  }
};
DoctorFinder.Views.ListResults.prototype.template = false;
